<template>
  <span>
    <button type="button" class="btn btn-primary" @click="showAddForm">
      Add a subgroup for this domain
    </button>

    <div v-if="showForm" class="modal-backdrop fade in"></div>
    <div v-if="showForm" class="modal fade in" style="display: block;">
      <div class="modal-dialog" role="dialog">
        <div class="modal-content">
          <SubgroupForm
            @save="handleSave"
            @cancel="closeForm"
          ></SubgroupForm>
        </div>
      </div>
    </div>
    <div v-if="errorMessage" class="alert alert-danger">
      {{ errorMessage }}
    </div>
  </span>
</template>

<script>
import SubgroupForm from './SubgroupForm.vue';

export default {
  name: 'AddSubgroupWrapper',
  components: {
    SubgroupForm,
  },
  props: {
    onSubgroupCreated: {
      type: Function,
      required: false,
      default: () => {},
    },
    domainUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
      errorMessage: '',
    };
  },
  methods: {
    showAddForm() {
      this.showForm = true;
    },
    closeForm() {
      this.showForm = false;
    },
    async handleSave(subgroup) {
      this.errorMessage = '';
      try {
        await this.$angularWorld.adminEntitiesApi.createSubgroup({ ...subgroup, domain_uuid: this.domainUuid });
        this.onSubgroupCreated();
        this.closeForm();
      } catch (error) {
        console.error('Failed to save subgroup', error);
        this.errorMessage = 'Failed to save subgroup';
        this.closeForm();
      }
    },
  },
};
</script>
